import { createContext } from 'react';
var defaultValues = {
    getNowTime: function () { return new Date(); }
};
export var DatetimeInputContext = createContext(defaultValues);
//# sourceMappingURL=DatetimeInputContext.js.map